import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { GoToHelpCenterCTA } from "./ctas";
import { CONTACT_US_IF_FURTHER_HELP } from "./shared";

export const OnboardingHowFaireWorksIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => HOW_FAIRE_WORKS_TITLE(strictLocalize),
    getDescription: () => [
      HOW_FAIRE_WORKS_DESCRIPTION(strictLocalize),
      CONTACT_US_IF_FURTHER_HELP(strictLocalize),
    ],
  };
};

const HOW_FAIRE_WORKS_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "General information about Faire",
    description: {
      text: "Title for the answer of how Faire works",
    },
  });

const HOW_FAIRE_WORKS_DESCRIPTION = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "You can find more information about Faire through our help center.",
  });

const getPrimaryCTA: CtaBuilderFn = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => GoToHelpCenterCTA(strictLocalize);
